import React from 'react';
import Swal from 'sweetalert2';

const ReportsCenter = () => {
    const reportData = {
        'Question SLA Performance': {
            headers: ['Question ID', 'Category', 'Speaker / Leader', 'Assigned Officer', 'Time Received', 'Time Resolved', 'SLA Status'],
            rows: [
                ['Q-104', 'Legislative', 'Speaker', 'Chief Secretary', '2026-06-20 10:00', '2026-06-20 11:30', 'COMPLIANT'],
                ['Q-105', 'Finance', 'Leader of Opposition', 'Finance Officer', '2026-06-21 09:00', '2026-06-21 14:15', 'OVERDUE'],
                ['Q-106', 'Security', 'Speaker', 'Security Admin', '2026-06-22 14:00', '2026-06-22 14:45', 'COMPLIANT'],
                ['Q-107', 'Legislative', 'Leader of Opposition', 'Chief Secretary', '2026-06-24 11:00', '2026-06-24 11:45', 'COMPLIANT'],
                ['Q-108', 'General', 'Speaker', 'Assistant Officer', '2026-06-25 09:00', '2026-06-25 10:20', 'COMPLIANT']
            ]
        },
        'Agenda Status Summary': {
            headers: ['Agenda ID', 'Title', 'Scheduled Date', 'Department', 'Presenting Minister', 'Status'],
            rows: [
                ['A-301', 'Bihar Land Reform Bill', '2026-06-28', 'Revenue & Land', 'Shri Nitish Kumar', 'APPROVED'],
                ['A-302', 'Budget Allocation 2026', '2026-06-29', 'Finance', 'Shri Samrat Choudhary', 'PENDING'],
                ['A-303', 'Secretariat Security Upgrade', '2026-06-30', 'Home Affairs', 'Shri Vijay Kumar Sinha', 'APPROVED'],
                ['A-304', 'Education Policy Amendments', '2026-07-02', 'Education', 'Shri Sunil Kumar', 'APPROVED'],
                ['A-305', 'Healthcare Infra Grant', '2026-07-05', 'Health Department', 'Shri Mangal Pandey', 'PENDING']
            ]
        },
        'Committee Activity Log': {
            headers: ['Log ID', 'Committee Name', 'Meeting Date', 'Attendees Count', 'Decisions Taken', 'Minutes Status'],
            rows: [
                ['C-501', 'Public Accounts Committee', '2026-06-18', '12', 'Audit report approved', 'FINALIZED'],
                ['C-502', 'Rules Committee', '2026-06-20', '8', 'Amendments proposed to Rule 14', 'DRAFT'],
                ['C-503', 'Library Committee', '2026-06-22', '6', 'Digital library budget cleared', 'FINALIZED'],
                ['C-504', 'House Committee', '2026-06-24', '15', 'Member housing queries resolved', 'FINALIZED'],
                ['C-505', 'Petitions Committee', '2026-06-25', '10', 'Review of petition 84', 'DRAFT']
            ]
        },
        'Financial Audit Report': {
            headers: ['Transaction ID', 'Official Name', 'Designation', 'Due Amount', 'Last Sync', 'Clearance Status'],
            rows: [
                ['T-801', 'Shri Abhi Jain', 'MP / Leader', '₹3,182', '2026-06-25 10:00', 'CLEARANCE PENDING'],
                ['T-802', 'Shri Satya dev', 'Secretary', '₹0', '2026-06-24 18:30', 'CLEARED'],
                ['T-803', 'Shri Ram Saran', 'MP', '₹15,000', '2026-06-25 11:15', 'CLEARANCE PENDING'],
                ['T-804', 'Shri Vijay Singh', 'MP', '₹0', '2026-06-23 15:40', 'CLEARED'],
                ['T-805', 'Shri Sanjay Prasad', 'MLA', '₹8,500', '2026-06-25 12:00', 'CLEARANCE PENDING']
            ]
        }
    };

    const handleExport = (type, reportName) => {
        const report = reportData[reportName];
        if (!report) {
            Swal.fire('Error', 'Report configuration not found.', 'error');
            return;
        }

        Swal.fire({
            title: `Generating ${type} Report`,
            html: `
                <p style="color: #666; font-size: 14px; margin-bottom: 20px;">
                    Please wait while we compile the "${reportName}" details...
                </p>
                <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 20px;">
                    <div style="width: 40px; height: 40px; border: 4px solid #F5F0E8; border-top: 4px solid #C0722C; border-radius: 50%; animation: swal-spin 1s linear infinite;"></div>
                </div>
                <style>
                    @keyframes swal-spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                </style>
            `,
            background: '#FDF8F3',
            timer: 1500,
            showConfirmButton: false
        }).then(() => {
            if (type === 'Excel') {
                let csvContent = "\uFEFF";
                csvContent += report.headers.join(",") + "\n";
                report.rows.forEach(row => {
                    csvContent += row.map(val => `"${String(val).replace(/"/g, '""')}"`).join(",") + "\n";
                });
                
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement("a");
                const url = URL.createObjectURL(blob);
                const cleanName = reportName.toLowerCase().replace(/[^a-z0-9]/g, '_');
                link.setAttribute("href", url);
                link.setAttribute("download", `${cleanName}_export_${new Date().toISOString().slice(0,10)}.csv`);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
                Swal.fire({
                    title: 'Download Successful',
                    text: `Excel/CSV Report for "${reportName}" downloaded successfully.`,
                    icon: 'success',
                    confirmButtonColor: '#2C1A10',
                    background: '#FDF8F3'
                });
            } else if (type === 'PDF') {
                const printWindow = window.open('', '_blank');
                if (!printWindow) {
                    Swal.fire({
                        title: 'Pop-up Blocked',
                        text: 'Please allow pop-ups for this website to export PDFs.',
                        icon: 'warning',
                        confirmButtonColor: '#2C1A10',
                        background: '#FDF8F3'
                    });
                    return;
                }
                printWindow.document.write(`
                    <html>
                        <head>
                            <title>${reportName} - Export</title>
                            <style>
                                @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;600;800&display=swap');
                                body { font-family: 'Outfit', sans-serif; padding: 40px; color: #2C1A10; background-color: #fff; }
                                .header { text-align: center; border-bottom: 3px double #C0722C; padding-bottom: 20px; margin-bottom: 30px; }
                                .logo { font-size: 28px; font-weight: 800; color: #2C1A10; letter-spacing: 1px; text-transform: uppercase; }
                                .subtitle { font-size: 14px; color: #C0722C; margin-top: 5px; font-weight: 700; text-transform: uppercase; letter-spacing: 2px; }
                                .meta { display: flex; justify-content: space-between; margin-bottom: 30px; font-size: 12px; color: #777; border-bottom: 1px solid #EAE2D5; padding-bottom: 10px; }
                                table { width: 100%; border-collapse: collapse; margin-top: 20px; font-size: 13px; }
                                th { background-color: #FDF8F3; border-bottom: 2px solid #EAE2D5; color: #2C1A10; font-weight: 800; text-transform: uppercase; padding: 12px; text-align: left; }
                                td { padding: 12px; border-bottom: 1px solid #F5F0E8; color: #555; }
                                tr:nth-child(even) { background-color: #FCFAF7; }
                                .footer { margin-top: 50px; text-align: center; font-size: 10px; color: #BBB; border-top: 1px solid #EAE2D5; padding-top: 15px; font-weight: 800; letter-spacing: 1.5px; }
                            </style>
                        </head>
                        <body>
                            <div class="header">
                                <div class="logo">Bihar Vidhan Sabha</div>
                                <div class="subtitle">${reportName}</div>
                            </div>
                            <div class="meta">
                                <div><strong>GENERATED BY:</strong> Secretariat Portal</div>
                                <div><strong>DATE:</strong> ${new Date().toLocaleString()}</div>
                            </div>
                            <table>
                                <thead>
                                    <tr>
                                        \${report.headers.map(h => \`<th>\${h}</th>\`).join('')}
                                    </tr>
                                </thead>
                                <tbody>
                                    \${report.rows.map(row => \`
                                        <tr>
                                            \${row.map(val => \`<td>\${val}</td>\`).join('')}
                                        </tr>
                                    \`).join('')}
                                </tbody>
                            </table>
                            <div class="footer">
                                SECURE GATEWAY AUDIT SYSTEM • CONSTITUTIONAL SECURITY CONTROL
                            </div>
                            <script>
                                window.onload = function() {
                                    window.print();
                                    setTimeout(function() { window.close(); }, 500);
                                };
                            </script>
                        </body>
                    </html>
                `);
                printWindow.document.close();
                
                Swal.fire({
                    title: 'Download Successful',
                    text: `PDF Report for "${reportName}" generated and sent to print queue.`,
                    icon: 'success',
                    confirmButtonColor: '#2C1A10',
                    background: '#FDF8F3'
                });
            }
        });
    };

    return (
        <div style={{ fontFamily: '"Outfit", sans-serif' }}>
            <h2 style={{ color: '#2C1A10', marginBottom: '30px', fontWeight: '800' }}>Reports Center & Analytics</h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '25px' }}>
                {[
                    { name: 'Question SLA Performance', desc: 'Average response time and officer efficiency tracking.' },
                    { name: 'Agenda Status Summary', desc: 'Weekly legislative agenda progress and approval rates.' },
                    { name: 'Committee Activity Log', desc: 'Detailed history of meetings, attendance, and minutes.' },
                    { name: 'Financial Audit Report', desc: 'Manual payment logs and reconciliation status.' }
                ].map((report, idx) => (
                    <div key={idx} style={{
                        backgroundColor: '#fff',
                        padding: '30px',
                        borderRadius: '20px',
                        boxShadow: '0 8px 30px rgba(0,0,0,0.03)',
                        borderTop: '6px solid #C0722C',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        minHeight: '200px'
                    }}>
                        <div>
                            <h3 style={{ margin: '0 0 10px 0', color: '#2C1A10', fontWeight: '800' }}>{report.name}</h3>
                            <p style={{ fontSize: '13px', color: '#777', lineHeight: '1.6' }}>{report.desc}</p>
                        </div>
                        <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
                            <button
                                onClick={() => handleExport('PDF', report.name)}
                                style={{
                                    flex: 1, padding: '10px', backgroundColor: '#FDF8F3', border: '1px solid #C0722C40',
                                    borderRadius: '10px', color: '#C0722C', fontWeight: '700', cursor: 'pointer', transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#C0722C10'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#FDF8F3'}
                            >
                                PDF
                            </button>
                            <button
                                onClick={() => handleExport('Excel', report.name)}
                                style={{
                                    flex: 1, padding: '10px', backgroundColor: '#FDF8F3', border: '1px solid #C0722C40',
                                    borderRadius: '10px', color: '#2E7D32', fontWeight: '700', cursor: 'pointer', transition: 'all 0.2s'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#2E7D3210'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = '#FDF8F3'}
                            >
                                Excel
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ReportsCenter;
